import type { IStore } from '../../../stores/Store';
import { getAdvertiserIds } from 'src/utils/advertiserIds';

interface RolloutSettings {
  rolloutPercentage: number;
  jobIdThreshold: number;
}

export const handleRolloutSettings = ({
  store,
  rolloutSettings,
  jobId,
}: {
  store: IStore;
  rolloutSettings: RolloutSettings;
  jobId: number | null;
}) => {
  const { seekAdvertiserId } = getAdvertiserIds();
  if (!seekAdvertiserId || !jobId) {
    return;
  }
  const moddedId = Number(seekAdvertiserId) % 100;

  if (
    moddedId < rolloutSettings.rolloutPercentage &&
    jobId > rolloutSettings.jobIdThreshold
  ) {
    store.featureStore.setSearchApiEnabled();
  }
};
